type LeftNavOption = {
  label: string;
  path?: string;
  method?: string;
  children?: LeftNavOption[];
};

export const leftnavOptions: LeftNavOption[] = [
  { label: "Home", path: "/" },

  {
    label: "Provisioning",
    path: "/provisioning",
    children: [
      { label: "Brand", path: "/provisioning/brand" },
      { label: "Family", path: "/provisioning/family" },
      { label: "Model", path: "/provisioning/model" },
      { label: "Firmware", path: "/provisioning/firmware" },
      { label: "Template", path: "/provisioning/template" },
      { label: "File", path: "/provisioning/file" },
    ],
  },
];
